import { disposeSafe, getEnumerator, comparePrimitives } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { some, value as value_1 } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { Union } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { union_type, class_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { getItemFromDict } from "../fable_modules/fable-library-js.4.29.0/MapUtil.js";

export function Enum_bitSetOrder(a_mut, b_mut) {
    Enum_bitSetOrder:
    while (true) {
        const a = a_mut, b = b_mut;
        if ((a === 0) ? true : (b === 0)) {
            return comparePrimitives(a, b) | 0;
        }
        else {
            const c = comparePrimitives(b & 1, a & 1) | 0;
            if (c === 0) {
                a_mut = (a >> 1);
                b_mut = (b >> 1);
                continue Enum_bitSetOrder;
            }
            else {
                return c | 0;
            }
        }
        break;
    }
}

export function Option_defaultOrMap(defaultValue, mapping, _arg) {
    if (_arg == null) {
        return defaultValue;
    }
    else {
        return mapping(value_1(_arg));
    }
}

export class Table$2 extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ReadOnlyDictionary"];
    }
}

export function Table$2_$reflection(gen0, gen1) {
    return union_type("StardewValleyStonks.Table`2", [gen0, gen1], Table$2, () => [[["Item", class_type("System.Collections.Generic.Dictionary`2", [gen0, gen1])]]]);
}

export function Table_addAll(dict, seq) {
    const enumerator = getEnumerator(seq);
    try {
        while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
            const forLoopVar = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            dict.set(forLoopVar[0], forLoopVar[1]);
        }
    }
    finally {
        disposeSafe(enumerator);
    }
    return dict;
}

export function Table_tryFind(key, table) {
    if (table.fields[0].has(key)) {
        return some(getItemFromDict(table.fields[0], key));
    }
    else {
        return undefined;
    }
}

//# sourceMappingURL=Prelude.js.map
